import type { InputHTMLAttributes } from 'react';

export interface CpmCheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
    label?: string;
}

export default function CpmCheckbox({
    label,
    className = '',
    checked,
    ...props
}: CpmCheckboxProps) {
    return (
        <label
            className={[
                'inline-flex items-center gap-2 cursor-pointer select-none',
                className,
            ].join(' ')}
        >
            <span
                className={[
                    'relative inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-[5px] border-[1.5px] transition-colors duration-150',
                    checked
                        ? 'border-[var(--cpm-brand-purple)] bg-[var(--cpm-brand-purple)]'
                        : 'border-[var(--cpm-border-strong)] bg-white',
                ].join(' ')}
            >
                <input
                    type="checkbox"
                    className="absolute inset-0 opacity-0 cursor-pointer"
                    checked={checked}
                    {...props}
                />
                {checked ? (
                    <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="3"
                    >
                        <path d="M20 6 9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                ) : null}
            </span>
            {label ? (
                <span className="text-[13px] font-semibold text-[var(--cpm-text-primary)]">
                    {label}
                </span>
            ) : null}
        </label>
    );
}
